import Footer from './Components/Layout/Footer';
import Header from './Components/Layout/Header';
import { AllOrders, Home, Login, MenuItemDetails, MenuItemList, MenuItemUpsert, MyOrders, NotFound, OrderConfirmed, OrderDetails, Payment, Register, ShoppingCart } from './Pages';
import {Routes,Route} from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useGetShoppingCartQuery } from './Apis/shoppingCartApi';
import React, { useEffect } from 'react'
import { setShoppingCart } from './Storage/Redux/shoppingCartSlice';
import { userModel } from './Interfaces';
import jwtDecode from 'jwt-decode';
import { setLoggedInUser } from './Storage/Redux/userAuthSlice';
import { RootState } from './Storage/Redux/store';

function App() {
  const dispatch = useDispatch();
  const userData: userModel = useSelector(
    (state: RootState) => state.userAuthStore
  );
  const {data,isLoading} = useGetShoppingCartQuery(userData.id)
  
  useEffect(() => {
  if(!isLoading){
    dispatch(setShoppingCart(data.result?.cartItems));
  }
  },[data])

  useEffect(() => {
    const localToken = sessionStorage.getItem("token");
    if (localToken) {
      const { fullName, id, email, role }: userModel = jwtDecode(localToken);
      dispatch(setLoggedInUser({ fullName, id, email, role }));
    }
  }, []);

  return (
    <>
    <Header/>
    <Routes>
      <Route path='/' element={<Home/>} />
      <Route path='/login' element={<Login/>} />
      <Route path='/register' element={<Register/>} />
      <Route path='/item/:menuItemId' element={<MenuItemDetails/>} />
      <Route path='/shoppingCart' element={<ShoppingCart/>} />
      <Route path='/payment' element={<Payment/>} />
      <Route path="order/orderconfirmed/:id" element={<OrderConfirmed />} ></Route>
      <Route path="/order/myOrders" element={<MyOrders />} />
      <Route path="/order/orderDetails/:id" element={<OrderDetails />} />
      <Route path="/order/allOrders" element={<AllOrders />} />
      <Route path="/menuItem/menuitemlist" element={<MenuItemList />} />
      <Route
            path="/menuItem/menuItemUpsert/:id"
            element={<MenuItemUpsert />}
          />
          <Route path="/menuItem/menuItemUpsert" element={<MenuItemUpsert />} />
      <Route path='*' element={<NotFound/>} />
     </Routes>
    </>
  );
}

export default App;
